/**
 * A callback for automatically scrolling to an element via element id.
 * @param id id of element to scroll to
 */
const navScrollTo = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    // include 96px offset from the nav bar
    const sectionTop = element.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: sectionTop, behavior: 'smooth' });
  }
};

export default navScrollTo;
